/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SystemDropdownCategory,
  SystemDropdownCategoryResponse,
  SystemDropdownOptionResponse,
  UpsertSystemDropdownOptionsRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SystemDropdownCategoryFromJSON,
    SystemDropdownCategoryToJSON,
    SystemDropdownCategoryResponseFromJSON,
    SystemDropdownCategoryResponseToJSON,
    SystemDropdownOptionResponseFromJSON,
    SystemDropdownOptionResponseToJSON,
    UpsertSystemDropdownOptionsRequestFromJSON,
    UpsertSystemDropdownOptionsRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetSystemDropdownOptionsRequest {
    category: SystemDropdownCategory;
    includeHidden?: boolean;
}

export interface UpsertSystemDropdownOptionsOperationRequest {
    category: SystemDropdownCategory;
    upsertSystemDropdownOptionsRequest: UpsertSystemDropdownOptionsRequest;
}

/**
 * SystemDropdownsApi - interface
 * 
 * @export
 * @interface SystemDropdownsApiInterface
 */
export interface SystemDropdownsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemDropdownsApiInterface
     */
    getSystemDropdownCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownCategoryResponse>>>;

    /**
     */
    getSystemDropdownCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownCategoryResponse>>;

    /**
     * 
     * @param {SystemDropdownCategory} category 
     * @param {boolean} [includeHidden] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemDropdownsApiInterface
     */
    getSystemDropdownOptionsRaw(requestParameters: GetSystemDropdownOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownOptionResponse>>>;

    /**
     */
    getSystemDropdownOptions(requestParameters: GetSystemDropdownOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownOptionResponse>>;

    /**
     * 
     * @param {SystemDropdownCategory} category 
     * @param {UpsertSystemDropdownOptionsRequest} upsertSystemDropdownOptionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemDropdownsApiInterface
     */
    upsertSystemDropdownOptionsRaw(requestParameters: UpsertSystemDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownOptionResponse>>>;

    /**
     */
    upsertSystemDropdownOptions(requestParameters: UpsertSystemDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownOptionResponse>>;

}

/**
 * 
 */
export class SystemDropdownsApi extends runtime.BaseAPI implements SystemDropdownsApiInterface {

    /**
     */
    async getSystemDropdownCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownCategoryResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/system-dropdowns`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemDropdownCategoryResponseFromJSON));
    }

    /**
     */
    async getSystemDropdownCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownCategoryResponse>> {
        const response = await this.getSystemDropdownCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSystemDropdownOptionsRaw(requestParameters: GetSystemDropdownOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownOptionResponse>>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getSystemDropdownOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeHidden'] != null) {
            queryParameters['includeHidden'] = requestParameters['includeHidden'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/system-dropdowns/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemDropdownOptionResponseFromJSON));
    }

    /**
     */
    async getSystemDropdownOptions(requestParameters: GetSystemDropdownOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownOptionResponse>> {
        const response = await this.getSystemDropdownOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertSystemDropdownOptionsRaw(requestParameters: UpsertSystemDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemDropdownOptionResponse>>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling upsertSystemDropdownOptions().'
            );
        }

        if (requestParameters['upsertSystemDropdownOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertSystemDropdownOptionsRequest',
                'Required parameter "upsertSystemDropdownOptionsRequest" was null or undefined when calling upsertSystemDropdownOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/system-dropdowns/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSystemDropdownOptionsRequestToJSON(requestParameters['upsertSystemDropdownOptionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemDropdownOptionResponseFromJSON));
    }

    /**
     */
    async upsertSystemDropdownOptions(requestParameters: UpsertSystemDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemDropdownOptionResponse>> {
        const response = await this.upsertSystemDropdownOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
